import axios from 'axios';
import { environment } from 'environments/environment';

export const getVariablesAsync = async () => {
    console.log('getVariablesAsync');
    let y: string[] = [];
    const getVars = async () => {
        await axios
            .get(`${environment.apiBaseUrl}devices/variables`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                // console.log(response);
                // console.log(response.data.data);
                y = response.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getVars();
    return y;
};

export default getVariablesAsync;
